import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { TimezoneSelectorComponent } from '../timezone-selector/timezone-selector.component';
import { Timezone } from '@lx/quote-tool/shared/types';
import { SelectorFieldContainerComponent, SidePanelComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-timezone-selector-field',
  templateUrl: './timezone-selector-field.component.html',
  styleUrls: ['./timezone-selector-field.component.scss'],
  imports: [SidePanelComponent, SelectorFieldContainerComponent, TimezoneSelectorComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimezoneSelectorFieldComponent),
      multi: true,
    },
  ],
})
export class TimezoneSelectorFieldComponent extends DialogBasedSelector<Timezone> {
  @Input() labelVisible = true;

  protected readonly timezoneLabel = $localize`Time zone`;
}
